











import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {IMAGE_POSITION, nil} from '@/common';
@Component({
    components: {
    },
})
export default class ImageTile extends Vue {
    public loading = false;

    @Prop({default: false})
    public value!: boolean;

    @Prop({default: () => null})
    public id!: string|null;

    @Prop({default: false})
    public selectable!: boolean;

    @Prop({default: false})
    public removable!: boolean;

    @Prop({default: false})
    public deletable!: boolean;

    @Prop({default: ''})
    public defaultImage!: string;

    @Prop({default: IMAGE_POSITION.CC})
    public position!: string;

    @Prop({default: 1})
    public aspectRatio!: number;

    @Prop({default: true})
    public fillHeight!: boolean;

    @Prop({default: ''})
    public imageStyle!: string;

    @Prop({default: false})
    public fullSize!: boolean;

    public imageModel: any|null = null;

    public mounted() {
        this.fetchImageModel();
    }
    public created() {
        this.fetchImageModel();
    }

    @Watch('id')
    public onIdChanged(value: string, oldValue: string) {
       if (nil(value)) {
           this.imageModel = null;
       } else {
           this.fetchImageModel();
       }
    }

    public async fetchImageModel() {
        if (!nil(this.id) && !this.loading) {
            const {Upload} = this.$FeathersVuex;
            this.loading = true;
            this.imageModel = await Upload.get(this.id);
            this.loading = false;
        }
    }
    public onClick() {
        if (this.selectable) {
            console.log(`image tile emitting new value: ${!this.value}`);
            this.$emit('input', !this.value);
        } else if (!this.removable) {
            this.$emit('onClick');
        }
    }
    public get imageSource() {
        return nil(this.imageModel) ? this.defaultImage : !nil(this.imageModel.thumb, true) ? this.imageModel.thumb : this.imageModel.file;
    }
}
